import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://blacktiedo.co.uk";
const DEFAULT_IMAGE =
  "https://images.unsplash.com/photo-1544125488-1bd845a0d0c5?auto=format&fit=crop&w=1600&q=85";

/**
 * SEO - per-route metadata via react-helmet-async.
 * Injects title, description, Open Graph, Twitter Card, and JSON-LD.
 */
export const SEO = ({
  title,
  description,
  image = DEFAULT_IMAGE,
  path = "/",
  type = "website",
  jsonLd,
  noIndex = false,
}) => {
  const fullTitle = title
    ? `${title} - BlackTieDo`
    : "BlackTieDo - The Portal for Britain's Formal Events";
  const desc =
    description ||
    "The private portal to Britain's charity balls, business awards and Highland balls - quietly curated, and rarely written about.";
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:site_name" content="BlackTieDo" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1600" />
      <meta property="og:image:height" content="1067" />
      <meta property="og:locale" content="en_GB" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {/* Editorial theme colour */}
      <meta name="theme-color" content="#0A0A0A" />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
